import { action, makeObservable, onBecomeObserved } from "mobx"

import {
  APIDataWithPagination,
  APIResponse,
  catchErrors,
  widgetApi,
} from "@src/shared/api"
import { Pagination, WidgetResponse } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

export class WidgetsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<WidgetResponse>,
) {
  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      remove: action.bound,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async fetch(req: { page: number }) {
    try {
      const { data: response } = await widgetApi.getWidgets(
        undefined,
        this.calcOffset(req.page),
        this.pageSize,
      )

      const { data } = response as APIResponse<
        APIDataWithPagination<WidgetResponse[]>
      >

      if (data) {
        return {
          data: data.data,
          pagination: data.pagination as Pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  async remove(id: string): Promise<any> {
    try {
      await widgetApi.deleteWidget(id)

      this.removeByKey({ id })
    } catch (e: any) {
      catchErrors(e)
    }
  }
}
